import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { DealNodeFragmentDoc } from '../fragments/dealNode.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DealQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type DealQuery = { __typename?: 'Query', deal?: { __typename?: 'DealNode', id: string, currency: Types.DealsDealCurrencyChoices, creationTime?: any | null, updateTime?: any | null, modelYear?: number | null, freeKmPerYear?: number | null, monthlyPayment?: number | null, fullMonthlyPrice?: number | null, deposit?: number | null, carPrice?: number | null, servicePrice?: number | null, totalPrice?: number | null, baseIndex?: number | null, participationFee?: number | null, residualPrice?: number | null, comprehensiveInsurancePrice?: number | null, comprehensiveInsuranceYoungPrice?: number | null, compulsoryInsurancePrice?: number | null, licenceAndInsurancePricePerMonth?: number | null, licencePrice?: number | null, leaseDuration: number, dealTypeString?: string | null, notes?: string | null, isOperational: boolean, status?: Types.DealsDealStatusChoices | null, startDate: any, endDate: any, signDate?: any | null, proposalNumberRef?: string | null, trackingMonthlyRate?: number | null, npv?: number | null, agent?: { __typename?: 'MeNode', id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, car?: { __typename?: 'CarNode', id: string, number: string, color?: string | null, carSubModel: { __typename?: 'CarSubModelNode', name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', name: string, localName?: string | null } } } | null, carSubModel?: { __typename?: 'CarSubModelNode', id: string, name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', id: string, name: string, localName?: string | null, brand: { __typename?: 'BrandNode', id: string, name: string } } } | null, proposal?: { __typename?: 'ProposalNode', id: string, currency: Types.DealsProposalCurrencyChoices, leaseDuration: number, isOperational: boolean, isLocked: boolean } | null, customer?: { __typename?: 'CustomerNode', id: string, email?: string | null, name: string, type: Types.CustomersCustomerTypeChoices, title?: Types.CustomersCustomerTitleChoices | null, shouldUnionInvoices: boolean } | null } | null };


export const DealDocument = gql`
    query Deal($id: ID!) {
  deal(id: $id) {
    ...DealNode
  }
}
    ${DealNodeFragmentDoc}`;

/**
 * __useDealQuery__
 *
 * To run a query within a React component, call `useDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDealQuery(baseOptions: Apollo.QueryHookOptions<DealQuery, DealQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealQuery, DealQueryVariables>(DealDocument, options);
      }
export function useDealLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealQuery, DealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealQuery, DealQueryVariables>(DealDocument, options);
        }
export type DealQueryHookResult = ReturnType<typeof useDealQuery>;
export type DealLazyQueryHookResult = ReturnType<typeof useDealLazyQuery>;
export type DealQueryResult = Apollo.QueryResult<DealQuery, DealQueryVariables>;